import { Box } from "@mui/material";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";

import { MuiButton } from "@ryde/controls";
import { IGeoJSON } from "@ryde/shared";

import { PolygonBlockSidebar } from "./polygon-block-sidebar";

export interface IPolygonBlockProps {
  value?: IGeoJSON;
  enabledImportAreas?: boolean;
  onChange?: (value: IGeoJSON) => void;
}

export const PolygonBlock: FC<IPolygonBlockProps> = ({
  value,
  enabledImportAreas,
  onChange,
}) => {
  const [isMapOpen, setIsMapOpen] = useState<boolean>(false);
  const { t } = useTranslation();

  return (
    <Box>
      <Box>
        <MuiButton
          onClick={() => setIsMapOpen(true)}
          sx={{ marginInlineEnd: "16px" }}
        >
          {value?.features?.length
            ? t("area.formLabel.editPolygons")
            : t("area.formLabel.addPolygons")}
        </MuiButton>
        {`${value?.features?.length || 0} ${t("area.formLabel.polygon", { count: value?.features?.length || 0 })}`}
      </Box>
      {isMapOpen && (
        <PolygonBlockSidebar
          value={value}
          enabledImportAreas={enabledImportAreas}
          isMapOpen={isMapOpen}
          setIsMapOpen={setIsMapOpen}
          onChange={onChange}
        />
      )}
    </Box>
  );
};
